import { setContext, ContextSetter } from 'apollo-link-context';
import { createQueryAndMutateFunctions } from './common';
import { ENDPOINTS } from '@/settings/endpoints';

export const forumAuth: ContextSetter = (_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  };
};

const forumAuthLink = setContext(forumAuth);

export const { query: forumQuery, mutate: forumMutation } = createQueryAndMutateFunctions(
  ENDPOINTS.forum,
  forumAuthLink,
);
